import { Component, OnInit } from '@angular/core';

import { CorePageBaseComponent } from '../core-page-base.component';

@Component({
  selector: 'cu-dynamic-page-validation',
  templateUrl: './page-validation.component.html'
})
export class PageValidationComponent extends CorePageBaseComponent implements OnInit {
  public ngOnInit(): void {}
}
